<template>
  <div class="workspace">
    <Header />
    <div class="workspace-content">
      <BlocksLibrary />
      <CanvasViewer />
      <AnnotationsPanel />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useHypothesesStore } from '@stores/hypotheses.store';
import Header from '@components/Header.vue';
import BlocksLibrary from '@components/BlocksLibrary.vue';
import CanvasViewer from '@components/CanvasViewer.vue';
import AnnotationsPanel from '@components/AnnotationsPanel.vue';

const route = useRoute();
const router = useRouter();
const hypothesesStore = useHypothesesStore();

const loadHypothesisFromRoute = async () => {
  const hypothesisId = route.params.hypothesisId;
  if (hypothesisId && typeof hypothesisId === 'string') {
    const id = parseInt(hypothesisId, 10);
    if (!isNaN(id)) {
      try {
        await hypothesesStore.loadHypothesis(id);
      } catch (error) {
        router.push('/');
      }
    }
  }
};

onMounted(async () => {
  const idParam = route.params.hypothesisId;
  const id = typeof idParam === 'string' ? parseInt(idParam, 10) : NaN;
  if (!isNaN(id)) {
    try {
      await Promise.all([
        hypothesesStore.fetchAll(),
        hypothesesStore.loadHypothesis(id),
      ]);
    } catch {
      await hypothesesStore.fetchAll();
      router.push('/');
    }
  } else {
    await hypothesesStore.fetchAll();
  }
});

watch(
  () => route.params.hypothesisId,
  () => {
    loadHypothesisFromRoute();
  }
);
</script>

<style scoped>
.workspace {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.workspace-content {
  flex: 1;
  display: flex;
  overflow: hidden;
}
</style>
